import { motion } from "framer-motion";

/**
 * Reveal — slides its children upward and fades them in
 * when they enter the viewport on scroll.
 */
export const Reveal = ({ children, className = "", delay = 0, y = 60 }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
